module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Visible-a444cb83746ec7d6203033dfa76d0c07.svg";